import { IState } from '../../store';

export function selectPriceChanges(state: IState) {
  return state.offerData.priceChanges;
}
